module.exports = __webpack_public_path__ + "img/download.018e7849.png";